import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-12" data-id="element-115">
      <div className="bg-white border-2 border-dashed border-gray-200 p-8 rounded-xl flex flex-col md:flex-row gap-6 items-center text-center md:text-left" data-id="element-116">
        <div className="shrink-0 bg-teal/10 p-4 rounded-full" data-id="element-117">
          <ShieldCheck className="w-8 h-8 text-teal-700" data-id="element-118" />
        </div>
        <div data-id="element-119">
          <h3 className="text-xl font-serif font-bold text-navy mb-2" data-id="element-120">
            Garantía (simple y limpia)
          </h3>
          <p className="text-gray-600" data-id="element-121">
            Si lo aplicas en tu próxima planeación y sientes que no te ahorró
            tiempo o no te dio más claridad, pides reembolso. Sin peleas.
          </p>
        </div>
      </div>
    </section>;
}